import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Container, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import DashboardLayout from "../../src/components/DashboardLayout";
import "../styles/ViewAllVendorsFinanceTeam.css";
import { useUser } from './Context/UserContext';
import VendorInfoTabs from "./VendorInfoTabs";
debugger;
const ViewAllVendorsCFO = () => {
    const [approvalHistory, setApprovalHistory] = useState([]); // Change the state name here
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [vendors, setVendors] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const { user } = useUser();
    const [showCard, setShowCard] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [activeTab, setActiveTab] = useState("details");
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [approvalStatuses, setApprovalStatuses] = useState([]);
    const [comment, setComment] = useState("");
    const [approvalError, setApprovalError] = useState("");
    const [commentError, setCommentError] = useState("");
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [subTab, setSubTab] = useState("details");
    const [approvalStatusError, setApprovalStatusError] = useState("");
    const [groupCodeError, setGroupCodeError] = useState("");
    const [accountSetError, setAccountSetError] = useState("");
    const [taxGroupsError, setTaxGroupsError] = useState("");
    const [termsCodeError, setTermsCodeError] = useState("");
    const [departmentTypeError, setDepartmentTypeError] = useState("");
    const [supplierTypeError, setSupplierTypeError] = useState("");
    const [statusError, setStatusError] = useState("");
    const [vendorCodeError, setVendorCodeError] = useState("");
    const [rejectionSendToError, setRejectionSendToError] = useState("");
    const [isdError, setIsdError] = useState("");
    const [isSaved, setIsSaved] = useState(false);
    const [isExisting, setIsExisting] = useState(false);
    const [vendorCode, setVendorCode] = useState("");
    const [departments, setDepartments] = useState([]);
    const [supplierTypes, setSupplierTypes] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [selectedSupplierTypeId, setSelectedSupplierTypeId] = useState("");
    const [groupCodes, setGroupCodes] = useState([]);
    const [taxGroups, setTaxGroups] = useState([]);
    const [accountSets, setAccountSets] = useState([]);
    const [statusMsg, setStatusMsg] = useState("");
    const [isInActive, setIsInActive] = useState(false);
    const [isOnHold, setIsOnHold] = useState(false);
    const [approverId, setApproverId] = useState(null);
    const [users, setUsers] = useState([]);
    const { user: loggedInUser } = useUser();
    const [selectedStatus, setSelectedStatus] = useState(3); // Pending default
    const [searchTerm, setSearchTerm] = useState("");
    /* const [backendStatus, setBackendStatus] = useState("Pending");*/
    const [backendStatus, setBackendStatus] = useState("3"); // Pending
    const [showSaveBtn, setShowSaveBtn] = useState(true);
    useEffect(() => {
        const fetchDropdowns = async () => {
            try {
                const [groupRes, taxRes, accRes] = await Promise.all([
                    axios.get("/api/dropdown/vendorgroups"),
                    axios.get("/api/dropdown/taxgroups"),
                    axios.get("/api/dropdown/accountsets"),
                ]);
                setGroupCodes(groupRes.data || []);
                setTaxGroups(taxRes.data || []);
                setAccountSets(accRes.data || []);
            } catch (err) {
                console.error("Failed to load dropdowns:", err);
            }
        };
        fetchDropdowns();
    }, []);
    useEffect(() => {
        const id = loggedInUser?.empId || sessionStorage.getItem("userId");
        if (id) {
            setApproverId(id); // ensure number
            console.log("✅ Approver ID set:", id);
        } else {
            console.log("⏳ Waiting for user info to load...");
        }
    }, [loggedInUser]);
    //const handleReviewClick = async (index) => {
    //    const vendor = vendors[index]; // Get vendor from list
    //    const vendorId = vendor?.id;
    //    if (!vendorId || isNaN(vendorId)) {
    //        console.error("Invalid vendor ID:", vendorId);
    //        return;
    //    }
    //    try {
    //        const res = await axios.get(`/api/vendordetails/vendor-details/${vendorId}`);
    //        console.log("🟢 Vendor details API response:", res.data);
    //        setSelectedVendor({
    //            ...res.data,
    //            userId: vendor.userId || vendor.UserId || vendor.userid || vendor.id || null,
    //            index
    //        });
    //        setIsExisting(false);
    //        setActiveTab("history");
    //        setShowModal(true);
    //        setIsEditing(false);
    //    } catch (err) {
    //        console.error("Error fetching vendor details", err);
    //    }
    //};
    const handleReviewClick = (index) => {
        const vendor = vendors[index]; //  Declare vendor first
        console.log("Clicked vendor:", vendor); //  Helps confirm structure
        console.log("Clicked vendor full object:", vendor); // <-- Add it here
        setSelectedVendor({
            ...vendor,
            userId: vendor.userId || vendor.UserId || vendor.userid || vendor.id || null, //  Ensure correct userId
            index
        });
        setShowModal(true);
        setIsEditing(false);
        //setActiveTab("history");
        setActiveTab("info");
    };
    const statusMapping = {
        Pending: 3,   // pStatusID = 1 → returns status 4
        Rejected: 2,  // pStatusID = 2 → returns 17,18
        Approved: 1   // pStatusID = 3 → returns 19
    };
    const mapBackendStatusToUI = (status) => {
        const approvedStatuses = [11];
        const rejectedStatuses = [8, 9, 10];
        if (approvedStatuses.includes(Number(status))) return "1"; // Approved
        if (rejectedStatuses.includes(Number(status))) return "2"; // Rejected
        return "3"; // Default → show nothing
    };

    const isReadOnly = backendStatus === "1" || backendStatus === "2";
    const isVendorVerified =
        selectedVendor?.isVerified === true ||
        selectedVendor?.isVerified === 1 ||
        selectedVendor?.isVerified === "1" ||
        selectedVendor?.IsVerified === true ||
        selectedVendor?.IsVerified === 1 ||
        selectedVendor?.IsVerified === "1";
    const isRejected = selectedVendor?.approvalStatus === "2";

    useEffect(() => {
        loadVendors(selectedStatus);
    }, [selectedStatus]);
    const loadVendors = async (status) => {
        try {
            if (!user?.empId) {
                console.error("User not loaded yet");
                return;
            }
            const res = await axios.get(
                "/api/vendordetails/details-finance",
                {
                    params: {
                        statusId: status,
                    }
                }
            );
            setVendors(res.data);
        } catch (error) {
            console.error("Error loading verifier vendors:", error);
        }
    };
    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const res = await axios.get("/department/department-id-name");
                console.log("Departments fetched from API:", res.data);
                setDepartments(res.data);
            } catch (err) {
                console.error("Failed to load departments", err);
            }
        };
        fetchDepartments();
    }, []);
    const handleDepartmentChange = async (e) => {
        const deptId = e.target.value;
        setSelectedVendor(prev => ({ ...prev, departmentType: deptId }));
        setDepartmentTypeError("");
        setSupplierTypes([]); // clear previous
        if (!deptId) return;
        try {
            const res = await axios.get(`/department/${deptId}`);
            const data = (res.data || []).map(s => ({ id: String(s.id), name: s.name }));
            setSupplierTypes(data);
            // Keep previous selected supplier type if it exists
            setSelectedVendor(prev => ({
                ...prev,
                supplierType: prev.supplierType || ""
            }));
        } catch (err) {
            console.error("Error fetching supplier types:", err);
        }
    };
    useEffect(() => {
        if (!selectedVendor?.departmentType) return;
        // fetch supplier types for this department
        axios.get(`/department/${selectedVendor.departmentType}`)
            .then(res => {
                const data = (res.data || []).map(s => ({ id: String(s.id), name: s.name }));
                setSupplierTypes(data);
                // Keep the previously selected supplierType from history
                setSelectedVendor(prev => ({
                    ...prev,
                    supplierType: prev.supplierType || ""
                }));
            })
            .catch(err => console.error("Error fetching supplier types:", err));
    }, [selectedVendor?.departmentType]);

    useEffect(() => {
        console.log("Selected Vendor:", selectedVendor);
        if (selectedVendor && selectedVendor.userId) {
            axios
                .get(`/api/approvalstatus/verifier-history/${selectedVendor.userId}`)
                .then(response => {
                    console.log("Approval History Data:", response.data);
                    setUsers(Array.isArray(response.data) ? response.data : []);
                })
                .catch(error => {
                    if (error.response?.status === 404) {
                        setUsers([]); // genuinely no history yet
                    } else {
                        console.error("Error fetching approval status:", error);
                        setUsers([]);
                    }
                });
        }
    }, [selectedVendor]);
    const filteredVendors = vendors.filter(vendor =>
        vendor.nameOfCompany?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const usersPerPage = 6; // Only 6 users per page
    const vendorsPerPage = 6;
    const startIndex = (currentPage - 1) * vendorsPerPage;
    const endIndex = startIndex + vendorsPerPage;
    const totalPages = Math.ceil(filteredVendors.length / vendorsPerPage);
    const vendorsForPage = filteredVendors.slice(startIndex, endIndex);
    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "Invalid Date";
        return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
    };
    const handlePageChange = (type) => {
        if (type === "first") setCurrentPage(1);
        if (type === "prev" && currentPage > 1) setCurrentPage(currentPage - 1);
        if (type === "next" && currentPage < totalPages) setCurrentPage(currentPage + 1);
        if (type === "last") setCurrentPage(totalPages);
    };
    console.log("Clicked user:", user);
    const handleInputChange = (e, field) => {
        setSelectedVendor({ ...selectedVendor, [field]: e.target.value });
    };
    const handleSort = (column) => {
        const sortedVendors = [...vendors].sort((a, b) => {
            let valueA, valueB;
            if (column === "approvalStatus") {
                valueA = a.approvalStatus?.toLowerCase() || "";
                valueB = b.approvalStatus?.toLowerCase() || "";
            }
            if (sortOrder === "asc") {
                return valueA > valueB ? 1 : -1;
            } else {
                return valueA < valueB ? 1 : -1;
            }
        });
        setVendors(sortedVendors);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        setSortBy(column);
    };
    const generateVendorCode = (companyName, gstNo) => {
        if (!companyName) return "";
        gstNo = gstNo || "";

        const prefix = companyName.replace(/[\s.]/g, "").substring(0, 4);
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const yyyy = today.getFullYear();
        const date = `${dd}${mm}${yyyy}`;
        const gstLast4 = gstNo.slice(-4);
        return (prefix + date + gstLast4).replace(/[\s.]/g, "");
    };
    useEffect(() => {
        console.log("📌 Auto-Generate useEffect Triggered");
        console.log("backendStatus:", backendStatus);
        if (!selectedVendor?.id) return;
        if (backendStatus === "3") {  // Pending
            console.log("🟢 Pending vendor — auto generating...");
            const auto = generateVendorCode(
                selectedVendor?.nameOfCompany,
                selectedVendor?.gst
            );
            setVendorCode(auto);
            setIsExisting(false);
        } else {  // Approved or Rejected
            console.log("🔒 Not pending — using existing vendor code:", selectedVendor.vendorCode);
            setVendorCode(selectedVendor.vendorCode || "");
            setIsExisting(true);
        }
    }, [selectedVendor?.id, backendStatus]);
    const rejectionCodeMap = {
        "Dept Head": "2",
        "PO": "3",
        "Vendor": "4"
    };
    const financeRejectionMap = {
        8: "Dept Head",
        9: "PO",
        10: "Vendor"
    };
    console.log("📌 Finance Rejection Map Loaded:", financeRejectionMap);
    useEffect(() => {
        if (!selectedVendor?.id || !approverId || !showModal) return;
        const fetchVendorHistory = async () => {
            try {
                const res = await axios.get(
                    "/api/approvalstatus/vendor-history",
                    { params: { vendorId: selectedVendor.id, approverId } }
                );
                console.log("📥 API Response:", res.data);
                const d = res.data;
                console.log("🔎 Backend Approval Status:", d.approvalStatus);
                const uiStatus = mapBackendStatusToUI(d.approvalStatus);
                console.log("🔄 Mapped UI Status:", uiStatus);
                setBackendStatus(uiStatus);
                // 🔍 LOG THE DECIDED REJECTION SEND TO
                const mappedSendTo = financeRejectionMap[d.approvalStatus];
                console.log("📌 Mapped Rejection Send To:", mappedSendTo);
                const fallbackSendTo = d.rejectionSendTo;
                console.log("📌 API Sent RejectionSendTo:", fallbackSendTo);
                const finalSendTo = mappedSendTo || fallbackSendTo || "";
                console.log("✅ Final Rejection Send To Used:", finalSendTo);
                if (uiStatus === "3") {
                    setSelectedVendor(prev => ({
                        ...prev,
                        isVerified:
                            d.isVerified === true ||
                            d.isVerified === 1 ||
                            d.isVerified === "1" ||
                            d.IsVerified === true ||
                            d.IsVerified === 1 ||
                            d.IsVerified === "1",
                        departmentType: "",
                        supplierType: "",
                        approvalStatus: "",
                        vendorCode: "",
                        accountSetCode: "",
                        taxGroup: "",
                        termsCode: "",
                        inActive: false,
                        onHold: false,
                        groupCode: "",
                        groupName: "",
                        rejectionSendTo: "",
                        isd: "",
                    }));
                    setVendorCode(
                        generateVendorCode(
                            d.nameOfCompany || selectedVendor?.nameOfCompany,
                            d.gst || selectedVendor?.gst
                        )
                    );
                    setComment("");
                    setIsExisting(false);
                } else {
                    setSelectedVendor(prev => ({
                        ...prev,
                        departmentType: d.departmentTYPE ? Number(d.departmentTYPE) : "",
                        supplierType: d.suppliertype || "",
                        approvalStatus: uiStatus,
                        vendorCode: d.vendorCode || "",
                        accountSetCode: d.accountSet || "",
                        taxGroup: d.taxGroups || "",
                        termsCode: d.termsCode || "",
                        inActive: d.inActive === 1 || d.inActive === true,
                        onHold: d.onHold === 1 || d.onHold === true,
                        groupCode: d.groupCode || "",
                        groupName: d.groupName || "",
                        // 🔥 FINAL VALUE TO SHOW ON UI
                        rejectionSendTo: rejectionCodeMap[finalSendTo] || "",
                        isd: d.isd ? Number(d.isd) : "",
                        isVerified:
                            d.isVerified === true ||
                            d.isVerified === 1 ||
                            d.isVerified === "1" ||
                            d.IsVerified === true ||
                            d.IsVerified === 1 ||
                            d.IsVerified === "1",
                    }));
                    setVendorCode(d.vendorCode || "");
                    setComment(d.approvalComments || "");
                    setIsExisting(true);
                }
            } catch (err) {
                console.error("❌ History loading error:", err);
            }
        };
        fetchVendorHistory();
    }, [selectedVendor?.id, approverId, showModal]);
    const statusMap = {
        8: "Vendor Rejected by Finance, Pending from Dept Head",
        9: "Vendor Rejected by Finance, Pending from PO",
        10: "Vendor Rejected by Finance, Pending from Vendor",
        11: "Approved by Finance, Pending from CFO",
        1: "Approved",
        2: "Rejected"
    };
    const handleSave = async () => {
        let isValid = true;
        // Clear all errors
        setApprovalStatusError("");
        setCommentError("");
        setRejectionSendToError("");
        setGroupCodeError("");
        setAccountSetError("");
        setTaxGroupsError("");
        setTermsCodeError("");
        setDepartmentTypeError("");
        setSupplierTypeError("");
        setStatusError("");
        setVendorCodeError("");
        setIsdError("");
        const isRejected = String(selectedVendor?.approvalStatus) === "2";
        // -----------------------------------------
        // 🟥 VALIDATION FOR REJECTED
        // -----------------------------------------
        if (isRejected) {
            if (!comment || comment.trim() === "") {
                setCommentError("Comment is required.");
                isValid = false;
            }
            if (!selectedVendor?.rejectionSendTo) {
                setRejectionSendToError("Rejection send to is required.");
                isValid = false;
            }
            // Skip all other validations
            if (!isValid) return;
        }
        if (!isVendorVerified && !isRejected) {
            setStatusError("Vendor details must be verified before approval.");
            return;
        }
        // -----------------------------------------
        // 🟩 VALIDATION FOR APPROVED & OTHERS
        // -----------------------------------------
        else {
            if (!selectedVendor?.approvalStatus) {
                setApprovalStatusError("Approval status is required.");
                isValid = false;
            }
            if (!selectedVendor?.accountSetCode) {
                setAccountSetError("Account Set is required.");
                isValid = false;
            }
            if (!selectedVendor?.taxGroup) {
                setTaxGroupsError("Tax Groups is required.");
                isValid = false;
            }
            if (!selectedVendor?.termsCode) {
                setTermsCodeError("Terms Code is required.");
                isValid = false;
            }
            if (!selectedVendor?.departmentType) {
                setDepartmentTypeError("Department Type is required.");
                isValid = false;
            }
            if (!selectedVendor?.supplierType || selectedVendor.supplierType === "0") {
                setSupplierTypeError("Supplier Type is required.");
                isValid = false;
            }
            //if (
            //    !isReadOnly &&
            //    !isRejected &&
            //    !selectedVendor?.inActive &&
            //    !selectedVendor?.onHold
            //) {
            //    setStatusError("Please select either InActive or On Hold");
            //    //isValid = false;
            //}
            if (isExisting) {
                if (!vendorCode || vendorCode.trim() === "") {
                    setVendorCodeError("Vendor Code is required for existing vendor.");
                    isValid = false;
                }
            } else {
                if (!vendorCode || vendorCode.trim() === "") {
                    setVendorCodeError("Auto-generated Vendor Code failed.");
                    isValid = false;
                }
            }
            if (!selectedVendor?.groupCode) {
                setGroupCodeError("Group Code is required.");
                isValid = false;
            }
            if (!comment || comment.trim() === "") {
                setCommentError("Comment is required.");
                isValid = false;
            }
            if (!selectedVendor?.isd || selectedVendor.isd === "0") {
                setIsdError("ISD selection is required.");
                isValid = false;
            }
            if (!isValid) return;
        }
        // ---------- SAVE LOGIC SAME ----------
        setSelectedVendor(prev => ({
            ...prev,
            approvalStatus: selectedVendor.approvalStatus,
        }));
        const payload = {
            UserId: selectedVendor.UserId,
            VendorId: selectedVendor.id,
            ApprovalStatus: selectedVendor.approvalStatus,
            ApproverId: approverId,
            Comments: comment,
            DepartmentType: selectedVendor.departmentType,
            SupplierType: selectedVendor.supplierType,
            VendorCode: vendorCode || "",
            InActive: selectedVendor.inActive ?? false,
            OnHold: selectedVendor.onHold ?? false,
            GroupCode: selectedVendor.groupCode || "",
            GroupName: selectedVendor.groupName || "",
            AccountSet: selectedVendor.accountSetCode || "",
            TaxGroups: selectedVendor.taxGroup || "",
            TermsCode: selectedVendor.termsCode || "",
            SendTo: selectedVendor.rejectionSendTo || "",
            ISD: parseInt(selectedVendor.isd || "0"),
            IsVerified:
                selectedVendor.isVerified ??
                selectedVendor.IsVerified ??
                false
        };
        try {
            console.log("Payload being sent:", payload);
            const response = await axios.post("/api/approvalstatus/submit", payload);
            alert(response.data.message);
            setShowModal(false);
            setVendors(prev => prev.filter(v => v.id !== selectedVendor.userId));
        } catch (error) {
            console.error(error);
            alert("Failed to submit approval: " + (error.response?.data?.error || error.message));
        }
    };
    const handleReject = () => {
        if (selectedVendor && selectedVendor.index !== undefined) {
            const updatedVendors = [...vendors];
            let rejectionCode;
            switch (selectedVendor.rejectionSendTo) {
                case "2": rejectionCode = 8; break; // Dept Head
                case "3": rejectionCode = 9; break; // PO
                case "4": rejectionCode = 10; break; // Vendor
                default: rejectionCode = 8;
            }
            console.log("Rejection sendTo:", selectedVendor.rejectionSendTo);
            console.log("Mapped rejection code:", rejectionCode);
            console.log("Mapped rejection text:", statusMap[rejectionCode]);
            updatedVendors[selectedVendor.index].approvalStatus = statusMap[rejectionCode];
            setVendors(updatedVendors);
        }
        setShowModal(false);
    };
    //const handleReject = () => {
    //    if (selectedVendor && selectedVendor.index !== undefined) {
    //        const updatedVendors = [...vendors];
    //        updatedVendors[selectedVendor.index].approvalStatus = "Rejected";
    //        setVendors(updatedVendors);
    //    }
    //    setShowModal(false);
    //};
    useEffect(() => {
        if (!statusMsg) return;
        const t = setTimeout(() => setStatusMsg(""), 3000);
        return () => clearTimeout(t);
    }, [statusMsg]);

    const handleInActiveChange = (e) => {
        if (isReadOnly) return;
        const checked = e.target.checked;
        setSelectedVendor(prev => ({
            ...prev,
            inActive: checked,
            onHold: checked ? false : prev.onHold
        }));
        setStatusError("");
        setStatusMsg(checked
            ? "Vendor marked as InActive (DeActivate)."
            : "Vendor marked as Active.");
    };

    const handleOnHoldChange = (e) => {
        if (isReadOnly) return;
        const checked = e.target.checked;
        setSelectedVendor(prev => ({
            ...prev,
            onHold: checked,
            inActive: checked ? false : prev.inActive
        }));
        setStatusError("");
        setStatusMsg(checked
            ? "Vendor marked as On Hold."
            : "Vendor removed from On Hold.");
    };
    return (
        <DashboardLayout>
            <div className="vendor-registration-details">
                <Container>
                    <h2 className="page-title" style={{ marginTop: 0, marginBottom: '20px', color: '#0a4275', paddingTop: '10px' }}>
                        Vendor Details
                    </h2>
                    <div className="vendor-toolbar">
                        {/* 🔹 Search Box — Left Side */}
                        <div className="vendor-toolbar-search">
                            <div className="vendor-search-box">
                                <span className="vendor-search-icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="11" cy="11" r="8" />
                                        <line x1="21" y1="21" x2="16.65" y2="16.65" />
                                    </svg>
                                </span>
                                <Input
                                    type="text"
                                    placeholder="Search by Company Name..."
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        setCurrentPage(1);
                                    }}
                                    aria-label="Search by company name"
                                    className="vendor-search-input"
                                />
                                {searchTerm && (
                                    <button
                                        type="button"
                                        className="vendor-search-clear"
                                        aria-label="Clear search"
                                        onClick={() => {
                                            setSearchTerm("");
                                            setCurrentPage(1);
                                        }}
                                    >
                                        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <line x1="6" y1="6" x2="18" y2="18" />
                                            <line x1="18" y1="6" x2="6" y2="18" />
                                        </svg>
                                    </button>
                                )}
                            </div>
                        </div>
                        {/* 🔹 Approved Status Dropdown — Right Side */}
                        <div className="vendor-status-filter">
                            <label className="vendor-status-label">
                                Approved Status:
                            </label>
                            <Input
                                type="select"
                                className="vendor-status-select"
                                value={selectedStatus}
                                onChange={(e) => {
                                    setSelectedStatus(e.target.value);
                                    setCurrentPage(1);
                                }}
                            >
                                <option value={statusMapping.Pending}>⏳ Pending</option>
                                <option value={statusMapping.Approved}>✔️ Approved</option>
                                <option value={statusMapping.Rejected}>❌ Rejected</option>
                            </Input>

                        </div>
                    </div>
                    {searchTerm && vendorsForPage.length === 0 && (
                        <div
                            style={{
                                color: "red",
                                fontWeight: "500",
                                marginBottom: "10px",
                                textAlign: "left", // under search box
                            }}
                        >
                            Company not found
                        </div>
                    )}
                    <Table bordered className="vendor-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Company Name</th>
                                <th>Contact Person</th>
                                <th>Nature of Supply</th>
                                <th>MSME</th>
                                <th>PAN Number</th>
                                <th>GST Number</th>
                                <th>HSN/SAC Code</th>
                                <th onClick={() => handleSort("approvalStatus")} style={{ cursor: "pointer" }}>
                                    Approval Status {sortBy === "approvalStatus"
                                        ? (sortOrder === "asc" ? "▲" : "▼")
                                        : "⇅"}
                                </th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {vendorsForPage.length === 0 ? (
                                <tr><td colSpan="10">No pending vendors found.</td></tr>
                            ) : (
                                vendorsForPage.map((vendor, index) => (
                                    <tr key={vendor.vendorCode || index}>
                                        <td>{startIndex + index + 1}</td>
                                        <td>
                                            {vendor.msmeNo && vendor.msmeNo !== "N/A" && (
                                                <div className="msme-badge-wrap">
                                                    <span className="msme-badge">MSME</span>
                                                </div>
                                            )}
                                            <div className="company-name-text">{vendor.nameOfCompany}</div>
                                        </td>
                                        <td>{vendor.contactPersonName || "N/A"}</td>
                                        <td>{vendor.natureOfSupply}</td>
                                        <td>{vendor.msmeNo || "N/A"}</td>
                                        <td>{vendor.pan || "N/A"}</td>
                                        <td>{vendor.gst || "N/A"}</td>
                                        <td>{vendor.hsNsacCode || "N/A"}</td>
                                        <td>{vendor.approvalStatus || "N/A"}</td>
                                        <td>
                                            <button className="review-btn" onClick={() => handleReviewClick(startIndex + index)}>
                                                Review
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                    <div className="pagination">
                        <button onClick={() => handlePageChange("first")} disabled={currentPage === 1}>First</button>
                        <button onClick={() => handlePageChange("prev")} disabled={currentPage === 1}>Previous</button>
                        <span className="page-info">Page {currentPage} of {totalPages}</span>
                        <button onClick={() => handlePageChange("next")} disabled={currentPage === totalPages}>Next</button>
                        <button onClick={() => handlePageChange("last")} disabled={currentPage === totalPages}>Last</button>
                    </div>
                </Container>
                <Modal isOpen={showModal} toggle={() => setShowModal(false)} centered className="modal-lg custom-modal">
                    <ModalHeader toggle={() => setShowModal(false)}>Vendor Details</ModalHeader>
                    <div className="tabs1">
                        <span className={activeTab === "history" ? "active-tab" : ""} onClick={() => setActiveTab("history")}>Vendor Approval History</span>
                        <span className={activeTab === "info" ? "active-tab" : ""} onClick={() => setActiveTab("info")}>Info</span>
                        <span className={activeTab === "details" ? "active-tab" : ""} onClick={() => setActiveTab("details")}>Approve/Reject</span>
                    </div>
                    <ModalBody>
                        {activeTab === "history" && selectedVendor && (
                            <div className="history-container">
                                <Table bordered className="history-table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Approval Status</th>
                                            <th>Approver Name</th>
                                            <th>Date</th>
                                            <th>Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {users.length > 0 ? (
                                            users.map((user, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    {/* <td>{user.approvalStatus || "N/A"}</td>*/}
                                                    <td>{user.approvalStatus || "N/A"}</td>
                                                    <td>{user.approvalName || "N/A"}</td>
                                                    <td>
                                                        {user.createDate
                                                            ? (() => {
                                                                const date = new Date(user.createDate);
                                                                const day = String(date.getDate()).padStart(2, "0");
                                                                const month = String(date.getMonth() + 1).padStart(2, "0");
                                                                const year = date.getFullYear();
                                                                const hours = String(date.getHours()).padStart(2, "0");
                                                                const minutes = String(date.getMinutes()).padStart(2, "0");
                                                                const seconds = String(date.getSeconds()).padStart(2, "0");
                                                                return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
                                                            })()
                                                            : "N/A"}
                                                    </td>
                                                    <td>{user.comments || "N/A"}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center">No history found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        )}
                        {activeTab === "info" && selectedVendor && (
                            <>
                                <VendorInfoTabs
                                    selectedVendor={selectedVendor}
                                    isEditing={isEditing}
                                    setIsEditing={setIsEditing}
                                    handleInputChange={handleInputChange}
                                    subTab={subTab}
                                    setSubTab={setSubTab}
                                    type="vendor"
                                />

                                <div style={{ marginTop: "12px", padding: "10px 0", borderTop: "1px solid #ddd" }}>
                                    <FormGroup check>
                                        <Label check style={{ fontSize: "13px" }}>
                                            <Input
                                                type="checkbox"
                                                disabled={isReadOnly || isVendorVerified}
                                                checked={
                                                    selectedVendor?.isVerified === true ||
                                                    selectedVendor?.isVerified === 1 ||
                                                    selectedVendor?.isVerified === "1" ||
                                                    selectedVendor?.IsVerified === true ||
                                                    selectedVendor?.IsVerified === 1 ||
                                                    selectedVendor?.IsVerified === "1"
                                                }


                                                onChange={async (e) => {
                                                    if (isReadOnly) return;

                                                    const isVerified = e.target.checked;

                                                    // Update the UI immediately
                                                    setSelectedVendor(prev => ({
                                                        ...prev,
                                                        isVerified
                                                    }));

                                                    try {
                                                        await axios.post("/api/approvalstatus/save-verification", {
                                                            VendorId: selectedVendor.id,
                                                            IsVerified: isVerified
                                                        });

                                                        console.log("Verification saved:", isVerified);
                                                    } catch (error) {
                                                        console.error(
                                                            "Failed to save verification:",
                                                            error.response?.data || error.message
                                                        );

                                                        alert("Failed to save verification. Please try again.");
                                                    }
                                                }}
                                            />
                                            {" "}
                                            <strong>Is Vendor Detail Verified?</strong>{" "}
                                            <span style={{
                                                color: selectedVendor?.isVerified ? "green" : "red",
                                                fontWeight: "bold"
                                            }}>
                                                {isVendorVerified ? "Yes" : "No"}
                                            </span>
                                        </Label>
                                    </FormGroup>
                                </div>
                            </>
                        )}
                        {activeTab === "details" && selectedVendor && (
                            <div className="details-container">
                                <Table bordered className="info-table1">
                                    <tbody>
                                        {/* ================= ALWAYS VISIBLE ================= */}
                                        <tr>
                                            <th>Approval Status:<span className="required-field">*</span></th>
                                            <td>
                                                <Input
                                                    type="select"
                                                    className="full-width-dropdown"
                                                    value={selectedVendor?.approvalStatus || ""}
                                                    disabled={isReadOnly}
                                                    onChange={(e) => {
                                                        if (isReadOnly) return;
                                                        setSelectedVendor({
                                                            ...selectedVendor,
                                                            approvalStatus: e.target.value,
                                                            rejectionSendTo: ""
                                                        });
                                                        setApprovalStatusError("");
                                                    }}
                                                >
                                                    {!isReadOnly && <option value="">Select</option>}
                                                    <option value="1">Approved</option>
                                                    <option value="2">Rejected</option>
                                                </Input>
                                                {approvalStatusError && (
                                                    <div className="text-danger">{approvalStatusError}</div>
                                                )}
                                            </td>
                                            <th>Comments:<span className="required-field">*</span></th>
                                            <td>
                                                <Input
                                                    type="textarea"
                                                    value={comment}
                                                    disabled={isReadOnly}
                                                    onChange={(e) => {
                                                        if (isReadOnly) return;
                                                        setComment(e.target.value);
                                                        setCommentError("");
                                                    }}
                                                    placeholder="Enter your comment..."
                                                />
                                                {commentError && (
                                                    <div className="text-danger">{commentError}</div>
                                                )}
                                            </td>
                                        </tr>
                                        {/* ================= REJECT ONLY ================= */}
                                        {isRejected && (
                                            <tr>
                                                <th>Rejection Send To:<span className="required-field">*</span></th>
                                                <td>
                                                    <Input
                                                        type="select"
                                                        className="full-width-dropdown"
                                                        value={selectedVendor?.rejectionSendTo || ""}
                                                        disabled={isReadOnly}
                                                        onChange={(e) => {
                                                            if (isReadOnly) return;
                                                            setSelectedVendor({
                                                                ...selectedVendor,
                                                                rejectionSendTo: e.target.value
                                                            });
                                                            setRejectionSendToError("");
                                                        }}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="2">Dept Head</option>
                                                        <option value="3">PO</option>
                                                        <option value="4">Vendor</option>
                                                    </Input>
                                                    {rejectionSendToError && (
                                                        <div className="text-danger">{rejectionSendToError}</div>
                                                    )}
                                                </td>
                                                <th></th>
                                                <td></td>
                                            </tr>
                                        )}
                                        {/* ================= SHOW ONLY WHEN NOT REJECTED ================= */}
                                        {!isRejected && (
                                            <>
                                                <tr>
                                                    <td colSpan="4">
                                                        <strong style={{ fontSize: "13px", fontWeight: "bold" }}>
                                                            Is Vendor Detail Verified?:{" "}
                                                        </strong>
                                                        <span style={{
                                                            fontSize: "13px",
                                                            color: isVendorVerified ? "green" : "red",
                                                            fontWeight: "bold"
                                                        }}>
                                                            {selectedVendor?.isVerified ? "Yes" : "No"}
                                                        </span>

                                                        {statusError && !isVendorVerified && !isRejected && (
                                                            <div className="text-danger"
                                                                style={{ fontSize: "13px", marginTop: "5px" }}>
                                                                {statusError}
                                                            </div>
                                                        )}
                                                        {!isVendorVerified && (
                                                            <span
                                                                style={{
                                                                    color: "red",
                                                                    fontSize: "13px",
                                                                    fontWeight: "500",
                                                                    marginLeft: "10px",
                                                                }}
                                                            >
                                                            </span>
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Name of Company:</th>
                                                    <td>{selectedVendor?.nameOfCompany || "N/A"}</td>
                                                    <th>Group Code:<span className="required-field">*</span></th>
                                                    <td>
                                                        <Input
                                                            type="select"
                                                            className="full-width-dropdown"
                                                            value={selectedVendor?.groupCode || ""}
                                                            disabled={isReadOnly}
                                                            onChange={(e) => {
                                                                if (isReadOnly) return;
                                                                const code = e.target.value;
                                                                const selected = groupCodes.find(
                                                                    g => g.groupcode === code
                                                                );
                                                                setSelectedVendor(prev => ({
                                                                    ...prev,
                                                                    groupCode: code,
                                                                    groupName: selected?.description || ""
                                                                }));
                                                                setGroupCodeError("");
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            {groupCodes.map(item => (
                                                                <option
                                                                    key={item.groupcode}
                                                                    value={item.groupcode}
                                                                >
                                                                    {item.groupcode} - {item.description}
                                                                </option>
                                                            ))}
                                                        </Input>
                                                        {selectedVendor?.groupCode && (
                                                            <Input
                                                                type="text"
                                                                disabled
                                                                value={selectedVendor?.groupName || ""}
                                                                style={{ marginTop: "10px", width: "170px" }}
                                                            />
                                                        )}
                                                        {groupCodeError && (
                                                            <div className="text-danger">{groupCodeError}</div>
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Account Set:<span className="required-field">*</span></th>
                                                    <td>
                                                        <Input
                                                            type="select"
                                                            className="full-width-dropdown"
                                                            value={selectedVendor?.accountSetCode || ""}
                                                            disabled={isReadOnly}
                                                            onChange={(e) => {
                                                                if (isReadOnly) return;
                                                                const code = e.target.value;
                                                                setSelectedVendor(prev => ({ ...prev, accountSetCode: code }));
                                                                setAccountSetError("");
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            {accountSets.map(item => (
                                                                <option key={item.accountSetCode} value={item.accountSetCode}>
                                                                    {item.accountSetCode} - {item.description}
                                                                </option>
                                                            ))}
                                                        </Input>
                                                        {accountSetError && (
                                                            <div className="text-danger">{accountSetError}</div>
                                                        )}
                                                    </td>
                                                    <th>Tax Groups:<span className="required-field">*</span></th>
                                                    <td>
                                                        <Input
                                                            type="select"
                                                            className="full-width-dropdown"
                                                            value={selectedVendor?.taxGroup || ""}
                                                            disabled={isReadOnly}
                                                            onChange={(e) => {
                                                                if (isReadOnly) return;
                                                                setSelectedVendor({
                                                                    ...selectedVendor,
                                                                    taxGroup: e.target.value
                                                                });
                                                                setTaxGroupsError("");
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            {taxGroups
                                                                .filter(
                                                                    item =>
                                                                        !item.taxGroup?.includes("194") ||
                                                                        item.description?.toLowerCase() === "exempted"
                                                                )
                                                                .map(item => (
                                                                    <option
                                                                        key={item.taxGroup}
                                                                        value={item.taxGroup}
                                                                    >
                                                                        {item.taxGroup} - {item.description}
                                                                    </option>
                                                                ))}
                                                        </Input>
                                                        {taxGroupsError && (
                                                            <div className="text-danger">{taxGroupsError}</div>
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Department Type:<span className="required-field">*</span></th>
                                                    <td>
                                                        <Input
                                                            type="select"
                                                            className="full-width-dropdown"
                                                            value={selectedVendor?.departmentType || ""}
                                                            disabled={isReadOnly}
                                                            onChange={handleDepartmentChange}
                                                        >
                                                            <option value="">Select</option>
                                                            {departments.map(dept => (
                                                                <option key={dept.id} value={dept.id}>
                                                                    {dept.name}
                                                                </option>
                                                            ))}
                                                        </Input>
                                                        {departmentTypeError && (
                                                            <div className="text-danger">{departmentTypeError}</div>
                                                        )}
                                                    </td>
                                                    <th>Supplier Type:<span className="required-field">*</span></th>
                                                    <td>
                                                        <Input
                                                            type="select"
                                                            className="full-width-dropdown"
                                                            value={selectedVendor?.supplierType || ""}
                                                            disabled={isReadOnly || isRejected}
                                                            onChange={(e) => {
                                                                // Safely check e.target
                                                                if (!e?.target) return;
                                                                const value = e.target.value;
                                                                setSelectedVendor(prev => ({ ...prev, supplierType: value }));
                                                                setSupplierTypeError("");
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            {supplierTypes.map((s, index) => (
                                                                // Use unique key: id + index
                                                                <option key={`${s.id}-${index}`} value={s.id}>{s.name}</option>
                                                            ))}
                                                        </Input>
                                                        {supplierTypeError && (
                                                            <div className="text-danger">{supplierTypeError}</div>
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Status:</th>
                                                    <td>
                                                        <div style={{ display: "flex", gap: "20px" }}>
                                                            <FormGroup check inline>
                                                                <Label check>
                                                                    <Input
                                                                        type="checkbox"
                                                                        disabled={isReadOnly}
                                                                        checked={selectedVendor?.inActive || false}
                                                                        onChange={handleInActiveChange}
                                                                    />
                                                                    InActive
                                                                </Label>
                                                            </FormGroup>
                                                            <FormGroup check inline>
                                                                <Label check>
                                                                    <Input
                                                                        type="checkbox"
                                                                        disabled={isReadOnly}
                                                                        checked={selectedVendor?.onHold || false}
                                                                        onChange={handleOnHoldChange}
                                                                    />
                                                                    On Hold
                                                                </Label>
                                                            </FormGroup>
                                                        </div>
                                                        {statusMsg && (
                                                            <div style={{ color: "green", fontSize: "13px", fontWeight: "500", marginTop: "6px" }}>
                                                                {statusMsg}
                                                            </div>
                                                        )}                                                       
                                                    </td>
                                                    <th>Vendor Code:<span className="required-field">*</span></th>
                                                    <td>
                                                        <FormGroup check inline>
                                                            <Label check>
                                                                <Input
                                                                    type="checkbox"
                                                                    disabled={isReadOnly}
                                                                    checked={isExisting}
                                                                    onChange={() => {
                                                                        if (isReadOnly) return;
                                                                        const newValue = !isExisting;
                                                                        setIsExisting(newValue);
                                                                        setVendorCodeError("");
                                                                        if (newValue) {
                                                                            setVendorCode("");
                                                                        } else if (backendStatus === "3") {
                                                                            const auto = generateVendorCode(
                                                                                selectedVendor?.nameOfCompany,
                                                                                selectedVendor?.gst
                                                                            );
                                                                            setVendorCode(auto);
                                                                        }
                                                                    }}
                                                                />
                                                                {" "}Existing
                                                            </Label>
                                                        </FormGroup>
                                                        {isExisting ? (
                                                            <Input
                                                                type="text"
                                                                placeholder="Enter Vendor Code"
                                                                value={vendorCode}
                                                                disabled={isReadOnly}
                                                                onChange={(e) => {
                                                                    setVendorCode(e.target.value);
                                                                    setVendorCodeError("");
                                                                }}
                                                                style={{ marginTop: "10px", width: "170px" }}
                                                            />
                                                        ) : (
                                                            <Input
                                                                type="text"
                                                                value={vendorCode}
                                                                disabled
                                                                style={{
                                                                    marginTop: "10px",
                                                                    width: "170px",
                                                                    backgroundColor: "#eee"
                                                                }}
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Terms Code:<span className="required-field">*</span></th>
                                                    <td>
                                                        <Input
                                                            type="select"
                                                            className="full-width-dropdown"
                                                            value={selectedVendor?.termsCode || ""}
                                                            disabled={isReadOnly}
                                                            onChange={(e) => {
                                                                if (isReadOnly) return;
                                                                setSelectedVendor({
                                                                    ...selectedVendor,
                                                                    termsCode: e.target.value
                                                                });
                                                                setTermsCodeError("");
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="DEF">DEF</option>
                                                            <option value="NET15">NET15</option>
                                                            <option value="NET20">NET20</option>
                                                            <option value="NET30">NET30</option>
                                                            <option value="NET45">NET45</option>
                                                        </Input>
                                                        {termsCodeError && (
                                                            <div className="text-danger">{termsCodeError}</div>
                                                        )}
                                                    </td>
                                                    <th>ISD (Input Service Distributor):<span className="required-field">*</span></th>
                                                    <td>
                                                        <Input
                                                            type="select"
                                                            className="full-width-dropdown"
                                                            value={selectedVendor?.isd || ""}
                                                            disabled={isReadOnly}
                                                            onChange={(e) => {
                                                                if (isReadOnly) return;
                                                                setSelectedVendor({
                                                                    ...selectedVendor,
                                                                    isd: e.target.value
                                                                });
                                                                setIsdError("");
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="1">YES</option>
                                                            <option value="2">NA</option>
                                                        </Input>
                                                        {isdError && (
                                                            <div className="text-danger">{isdError}</div>
                                                        )}
                                                    </td>
                                                </tr>
                                            </>
                                        )}
                                    </tbody>
                                </Table>
                                <ModalFooter>
                                    {!isReadOnly && (
                                        <Button color="success" onClick={handleSave}>
                                            Save
                                        </Button>
                                    )}
                                    <Button color="danger" onClick={() => setShowModal(false)}>
                                        Close
                                    </Button>
                                </ModalFooter>
                            </div>
                        )}
                    </ModalBody>
                </Modal>
            </div>
        </DashboardLayout >
    );
};
export default ViewAllVendorsCFO;
